import { ModelBase } from '../../core/model/model-base';

export class ArticleGroup extends ModelBase {
  name: string;
  isRent: boolean = false;

  toJSON() {
    return {
      id: this.id,
      name: this.name,
      isRent: this.isRent,
    };
  }

  toString() {
    return this.name;
  }
}
